import React from "react"
import { Panel, Modal } from "react-bootstrap"
import Calendar from 'react-widgets/lib/Calendar'
import { range } from "lodash"
import moment from "moment"
import Markdown from "react-markdown"

import HoverTip from "../components/HoverTip"
import { checkDate } from "./timetable"
import Button from "../components/Button"
import { date2str } from "../../lib/Tools"

import "./TimeTableCalendar.less"

/**
 *
 */

const Day = ({ timetable, date, label }) => {
  const status = checkDate(timetable, date)
  return (
    <div
      className={`day ${status.definitionType} ${status.open ? "open" : "closed"}`}
    >
      <HoverTip text={status.open ? `Abierto: ${status.times.join(", ")}` : "Cerrado"}>
        <span>{label}</span>
      </HoverTip>
    </div>
  )
}

const dayWithTimetable = (timetable) => props => <Day {...props} timetable={timetable} />
// No entiendo este error de eslint :(

const monthsRange = () => {
  const r = []
  const m = moment().startOf("month")
  r.push(m.format("YYYY/MM/DD"))
  range(0, 11).forEach(() => r.push(m.add(1, "month").format("YYYY/MM/DD")))
  return r
}

const Legend = () => (
  <div className="legend">
    <div>
      <div className="square open">&nbsp;</div>
      <label>Abierto</label>
    </div>
    <div>
      <div className="square closed">&nbsp;</div>
      <label>Cerrado</label>
    </div>
    <div>
      <div className="square open exception">&nbsp;</div>
      <span>/</span>
      <div className="square closed exception">&nbsp;</div>
      <label>Excepciones</label>
    </div>
  </div>
)

/**
 *
 */

class TimeTableCalendar extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = { selectedDate : null }
  }

  render() {
    const { timetable } = this.props
    const { selectedDate } = this.state
    const selectedDateStatus = selectedDate && checkDate(timetable, selectedDate)

    return (
      <div className="timetable-calendar">
        <Legend />
        <div className="year">
          {
            monthsRange().map(monthStart => (
              <div key={monthStart} className="cal-wrapper">
                <Calendar
                  key={monthStart}
                  readonly
                  culture="es"
                  className="cal"
                  currentDate={new Date(monthStart)}
                  footer={false}
                  views={["month"]}
                  dayComponent={dayWithTimetable(timetable)}
                  onChange={date => this.setState({ selectedDate: date2str(date) })}
                />
              </div>
            ))
          }
        </div>

        {
          this.state.selectedDate && (
            <Modal show onHide={() => this.setState({ selectedDate: null })}>
              <Modal.Header>
                <Modal.Title>Horarios del {selectedDate}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <p>
                  {
                    selectedDateStatus.open
                      ? "✔️ Horarios disponibles: " + selectedDateStatus.times.join(", ")
                      : "🙅‍♀️ Cerrado"
                  }
                </p>
                {
                  selectedDateStatus.note && (
                    <div style={{ marginTop: 20 }}>
                      <label>Nota:</label>
                      <div style={{ paddingLeft: "20px" }}>
                        <Markdown source={selectedDateStatus.note} />
                      </div>
                    </div>
                  )
                }
              </Modal.Body>
              <Modal.Footer>
                <Button onClick={() => this.setState({ selectedDate: null })} label="Cerrar" />
              </Modal.Footer>
            </Modal>
          )
        }
      </div>
    )
  }
}

export default TimeTableCalendar
